<template>
  <body class="body1">
  <div class="bg1">
    <img src="../model/Images/bg3.png" class="bg-img" style="object-fit: cover;">
  </div>
  <div class="container">
<!--    <img src="../model/Images/title6.png" style="width:480px">-->
    <div class="title" style="font-size:45px;">修改密码</div>
    <br>
    <div style="background-color: rgba(248,246,246,0.3);display: inline-block;padding: 15px;border-radius: 6px;margin-top: 10px">
    <div class="box-width"><input type="text" placeholder="用户名" v-model="changeForm.loginName" clearable class="txt" readonly style="border: none"></div>
    <div class="box-width"><input type="password" placeholder="请输入旧密码" v-model="changeForm.oldPassword" clearable class="txt"></div>
    <div class="box-width"><input type="password" placeholder="请输入新密码" v-model="changeForm.newPassword" clearable class="txt"></div>
    <div class="box-width"><input type="password" placeholder="请确认新密码" v-model="changeForm.newPasswordAgain" clearable class="txt"></div>
    <div class="box-width"><button class="btnNew btnNew-login" @click="submit">提交</button></div>
<!--      <div class="box-width"><button class="btnNew btnNew-login" @click="cancel">返回</button></div>-->
      <div style="font-size: 13px;margin-top: 6px;" @click="cancel">返回</div>
    </div>
  </div>
  </body>
</template>

<script>
import axios from 'axios'
import Welcome from './Welcome'

export default {
  name: 'ChangePassword',
  data () {
    return {
      changeForm: {
        loginName: Welcome.methods.getLocalStorage('loginName'),
        oldPassword: '',
        newPassword: '',
        newPasswordAgain: ''
      }
    }
  },
  methods: {
    submit: function () {
      if (this.changeForm.loginName === '' || this.changeForm.oldPassword === '' || this.changeForm.newPassword === '' || this.changeForm.newPasswordAgain === '') {
        this.notification('账号或密码不能为空')
      } else if (this.changeForm.newPassword !== this.changeForm.newPasswordAgain) {
        this.notification('新密码不一致，请重新输入')
      } else {
        axios.post('/pwdReset', this.changeForm).then(res => {
          if (res.data['result'] === '修改密码成功') {
            // 清除token
            localStorage.clear()
            this.$router.push('/')
            this.successNotification('修改密码成功，请重新登录')
          } else {
            this.notification('修改密码失败，' + res.data['result'])
          }
        }).catch(error => {
          this.notification('修改密码失败，请联系管理员，错误信息：' + error)
        })
      }
    },
    cancel: function () {
      this.$router.push('/home')
    },
    notification (msg) {
      const h = this.$createElement
      this.$message.error({
        message: h('i', {style: 'color: grey'}, msg),
        center: true
      })
    },
    successNotification (msg) {
      const h = this.$createElement
      this.$message({
        message: h('i', {style: 'color: green'}, msg),
        type: 'success',
        center: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../model/Css/public.css";
  @import "../model/Css/drop-down.css";
  #poster {
    background:url("../assets/background.jpg") no-repeat;
    background-position: center;
    height: 100%;
    width: 100%;
    background-size: cover;
    position: fixed;
  }
  body{
    margin: 0px;
    padding: 0;
  }
  .ChangePassword{
    margin: auto;
    padding: 0;
    position: relative;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    /*font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: rgba(129, 244, 233, 0.29);
    margin-top: 100px;
  }
  .input_style{
    width: 200px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/ChangePassword.vue